const INITIALIZED_FLAG = "skapa-shadow-focus-feature";
let inited = false;
let isMouseDown = false;
let shadowDomOnly = false;
let hadKeyboardEvent = false;
let listenerCount = 0;
const activeShadowDoms = [];
function handleKey(event) {
  if (!(event.ctrlKey || event.altKey || event.metaKey)) {
    hadKeyboardEvent = true;
    if (event.type === "keydown") {
      const target = event.composedPath()[0];
      if (["input", "textarea"].includes(target.tagName.toLowerCase()) || target.hasAttribute("tabIndex") && target.tabIndex >= 0) {
        fVisible([target], true);
      }
    }
  }
}
function purgeAllFocus() {
  activeShadowDoms.map(ignoreFocusEvents);
}
function handleMouse(event) {
  hadKeyboardEvent = false;
  isMouseDown = event.type === "pointerdown";
  purgeAllFocus();
  const path = event.composedPath();
  const shadows = getShadowDomsFromChain(path[0]);
  shadows.map(listenForFocusEvents);
}
function fVisible(elements, on = true) {
  if (elements) {
    elements.forEach(
      (element) => element.classList.toggle("focus-visible", on)
    );
  }
}
function getShadowDomsFromChain(leafNode) {
  const result = [];
  let leaf = leafNode;
  let shadow;
  while ((shadow = leaf.getRootNode()) !== document && shadow.nodeType === 11) {
    result.push(shadow);
    leaf = shadow.host;
  }
  return result;
}
function listenForFocusEvents(shadow) {
  shadow.addEventListener("focusin", microHandleFocus);
  shadow.addEventListener("focusout", microHandleFocus);
  activeShadowDoms.push(shadow);
  listenerCount += 2;
}
function ignoreFocusEvents(shadow) {
  shadow.removeEventListener("focusin", microHandleFocus);
  shadow.removeEventListener("focusout", microHandleFocus);
  activeShadowDoms.splice(activeShadowDoms.indexOf(shadow), 1);
  listenerCount -= 2;
}
function handleFocus(event) {
  const eventChainTip = event.path[0];
  if (event.type === "focusin") {
    const shadows = getShadowDomsFromChain(event.path[0]);
    const newShadows = shadows.filter((e) => !activeShadowDoms.includes(e));
    const garbageShadows = activeShadowDoms.filter((e) => !shadows.includes(e));
    garbageShadows.map(ignoreFocusEvents);
    newShadows.map(listenForFocusEvents);
    if (hadKeyboardEvent && !isMouseDown) {
      if (shadowDomOnly && shadows.length || // if it is in shadowDomOnly mode then it checks if the tip of the event chain is inside at least one shadowDom.
      !shadowDomOnly)
        fVisible([eventChainTip], true);
    }
  } else {
    fVisible([eventChainTip], false);
    if (!event.relatedTarget) {
      purgeAllFocus();
    }
  }
}
const micro = (callback) => (event) => {
  const duplicateEvent = {
    relatedTarget: event.relatedTarget,
    target: event.target,
    type: event.type,
    path: event.composedPath()
  };
  setTimeout(() => callback(duplicateEvent));
};
const microHandleFocus = micro(handleFocus);
function applyFocusVisible(listenerBase) {
  if (inited)
    return;
  if (typeof window !== "undefined" && window.hasOwnProperty("applyFocusVisiblePolyfill"))
    shadowDomOnly = true;
  if (!shadowDomOnly) {
    window.addEventListener(
      "focus-visible-polyfill-ready",
      // Based on: https://github.com/WICG/focus-visible#lazy-loading
      () => shadowDomOnly = true,
      // Make sure that the tool sets itself to complementary mode if the conventional polyfill is loaded.
      { once: true }
    );
  }
  listenerBase = listenerBase || document.documentElement;
  if (listenerBase.hasAttribute(INITIALIZED_FLAG))
    return;
  listenerBase.addEventListener("keydown", handleKey);
  listenerBase.addEventListener("keyup", handleKey);
  listenerBase.addEventListener("pointerdown", handleMouse);
  listenerBase.addEventListener("pointerup", handleMouse);
  listenerBase.addEventListener("drag", handleMouse);
  listenerBase.addEventListener("focusin", microHandleFocus);
  listenerBase.addEventListener("focusout", microHandleFocus);
  if (!listenerBase.toggleAttribute) {
    listenerBase.toggleAttribute = (qualifiedName, force) => {
      if (force)
        listenerBase?.setAttribute(qualifiedName, "");
      else
        listenerBase?.removeAttribute(qualifiedName);
      return Boolean(force);
    };
  }
  listenerBase.toggleAttribute(INITIALIZED_FLAG, true);
  listenerBase.classList.add("js-focus-visible");
  inited = true;
}
export {
  applyFocusVisible as default
};
